import React from 'react';

import { IconProps } from './types';

export const Add2Icon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="32"
        viewBox="0 0 32 32"
        width="32"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M16.6511 9.9857C16.099 9.99482 15.6589 10.4479 15.6667 11V15H11.6667C11.306 14.9948 10.9701 15.1849 10.7891 15.4961C10.6068 15.8073 10.6068 16.1927 10.7891 16.5039C10.9701 16.8151 11.306 17.0052 11.6667 17H15.6667V21C15.6615 21.3607 15.8516 21.6966 16.1628 21.8776C16.474 22.0599 16.8594 22.0599 17.1706 21.8776C17.4818 21.6966 17.6719 21.3607 17.6667 21V17H21.6667C22.0274 17.0052 22.3633 16.8151 22.5443 16.5039C22.7266 16.1927 22.7266 15.8073 22.5443 15.4961C22.3633 15.1849 22.0274 14.9948 21.6667 15H17.6667V11C17.6706 10.7292 17.5651 10.4701 17.3737 10.2787C17.1823 10.0873 16.9219 9.98179 16.6511 9.9857Z"
          fill={color}
        />
        <path
          d="M29.6668 16C29.6668 23.1797 23.8465 29 16.6668 29C9.48706 29 3.66676 23.1797 3.66676 16C3.66676 8.8203 9.48706 3 16.6668 3"
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M29.6668 16C29.6668 8.8203 23.8465 3 16.6668 3"
          stroke={color}
          strokeDasharray="1 4"
          strokeWidth="2"
        />
      </svg>
    );
  },
);
